// React
import { useState } from 'react';

// Mantine
import { Badge, Select } from '@mantine/core';
import { MRT_ColumnDef } from 'mantine-react-table';

// Interface
import { Admin } from 'interfaces';

//TODO: readd validation
export const AdminColumns = () => {
  const columns: MRT_ColumnDef<Admin>[] = [
    {
      accessorKey: 'firstName',
      header: 'First Name',
      mantineEditTextInputProps: () => ({
        required: true,
        placeholder: 'First Name',
        errorProps: { 'data-testid': 'firstName-input-error' },
      }),
    },
    {
      accessorKey: 'lastName',
      header: 'Last Name',
      mantineEditTextInputProps: () => ({
        required: true,
        placeholder: 'Last Name',
      }),
    },
    {
      accessorKey: 'email',
      header: 'Email',
      mantineEditTextInputProps: () => {
        return {
          required: true,
          placeholder: 'Email',
        };
      },
    },
    {
      accessorKey: 'phone',
      header: 'Phone Number',
      mantineEditTextInputProps: () => {
        return {
          required: true,
          placeholder: 'Phone Number',
        };
      },
    },
    {
      accessorKey: 'status',
      header: 'Account Status',
      Edit: ({ cell }) => {
        const cellStatus: any = cell.getValue();
        const [status, setStatus] = useState<string>(cellStatus);

        return (
          <Select
            label="Status"
            data={['active', 'inactive']}
            value={status}
            onChange={(e) => {
              setStatus(e); // likely useless
              cell.row._valuesCache.status = e;
            }}
          />
        );
      },
      Cell: ({ cell }) => (
        <Badge color={cell.getValue() === 'active' ? 'teal' : 'gray'}>
          {cell.getValue() as string}
        </Badge>
      ),
    },
  ];
  return columns;
};
